module.exports = __webpack_public_path__ + "static/media/4.9ec6eff9.gif";